import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import LanguageToggle from "./LanguageToggle";
import LoginRegisterButton from "./LoginRegisterButton";
import { useI18n } from "../../i18n";

/**
 * On the home page the bar floats over the hero photo and turns solid once
 * the guest scrolls; everywhere else it is solid from the start.
 */
export default function Topbar({ logo, name }) {
  const { t } = useI18n();
  const { pathname } = useLocation();
  const overHero = pathname === "/";
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    if (!overHero) return undefined;
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [overHero]);

  return (
    <header className={`f-topbar ${overHero ? "over" : ""} ${scrolled ? "scrolled" : ""}`}>
      <div className="f-topbar-inner">
        <Link to="/" className="f-topbar-brand" aria-label={t("nav.home", { name: name || "" })}>
          {logo && <img src={logo} alt="" width="150" height="48" fetchpriority="high" decoding="async" />}
          {/* The logo is the hotel's name; the text only stands in when there is none. */}
          {!logo && name && <span>{name}</span>}
        </Link>

        <div className="f-topbar-actions">
          <LanguageToggle />
          <LoginRegisterButton />
        </div>
      </div>
    </header>
  );
}
